export const landingHeroConfig = {
  chart: {
    source: 'Binance spot',
    network: 'Solana only',
    intervals: [
      { label: '15m', value: '15m', seconds: 900 },
      { label: '1H', value: '1h', seconds: 3600 },
      { label: '4H', value: '4h', seconds: 14400 },
    ],
  },
  // Landing admin knobs: keep this to four rows for the terminal preview.
  featuredMarkets: [
    {
      symbol: 'SOL',
      pairLabel: 'SOL / USDT',
      binanceSymbol: 'SOLUSDT',
      price: '$77.74',
      move: '+6.01%',
      leverage: '7x',
      collateral: '0.50 SOL',
      protocolFill: '3.00 SOL',
      position: '3.50 SOL',
      fee: '2.0%',
      fallbackPrice: 77.74,
    },
    {
      symbol: 'JUP',
      pairLabel: 'JUP / USDT',
      binanceSymbol: 'JUPUSDT',
      price: '$0.2349',
      move: '+13.15%',
      leverage: '5x',
      collateral: '0.60 SOL',
      protocolFill: '2.40 SOL',
      position: '3.00 SOL',
      fee: '3.0%',
      fallbackPrice: 0.2349,
    },
    {
      symbol: 'WIF',
      pairLabel: 'WIF / USDT',
      binanceSymbol: 'WIFUSDT',
      price: '$0.1719',
      move: '+2.02%',
      leverage: '7x',
      collateral: '0.45 SOL',
      protocolFill: '2.70 SOL',
      position: '3.15 SOL',
      fee: '2.0%',
      fallbackPrice: 0.1719,
    },
    {
      symbol: 'RAY',
      pairLabel: 'RAY / USDT',
      binanceSymbol: 'RAYUSDT',
      price: '$0.6501',
      move: '+6.10%',
      leverage: '5x',
      collateral: '0.70 SOL',
      protocolFill: '2.80 SOL',
      position: '3.50 SOL',
      fee: '3.0%',
      fallbackPrice: 0.6501,
    },
  ],
} as const;
